import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Assessment from "@/pages/Assessment";
import Results from "@/pages/Results";
import Admin from "@/pages/Admin";
import HowScoreWorks from "@/pages/HowScoreWorks";
import HowItWorks from "@/pages/HowItWorks";
import Accessibility from "@/pages/Accessibility";
import PlanningYoung from "@/pages/PlanningYoung";
import PlanningMid from "@/pages/PlanningMid";
import RetirementGuide from "@/pages/RetirementGuide";
import FAQ from "@/pages/FAQ";
import Privacy from "@/pages/Privacy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/assessment" element={<Assessment />} />
          <Route path="/results" element={<Results />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/leads" element={<Admin />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/how-the-score-works" element={<HowScoreWorks />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="/financial-planning-20s-30s" element={<PlanningYoung />} />
          <Route path="/financial-planning-40s-50s" element={<PlanningMid />} />
          <Route path="/retirement-readiness-guide" element={<RetirementGuide />} />
          <Route path="/financial-readiness-faq" element={<FAQ />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
